import { FormControl, InputLabel, ListItemText, MenuItem, Select, Switch } from '@mui/material';
import React from 'react';

interface Exemptions {
	tax1: boolean;
	tax2: boolean;
	tax3: boolean;
	tax4: boolean;
}

export const TaxExemptionsSelect = ({
	exemptions,
	onChange,
	disabled = false,
}: {
	exemptions: Exemptions;
	onChange: (exemptions: Exemptions) => void;
	disabled?: boolean;
}) => {
	const areAllSelected = Object.values(exemptions).every((tax) => tax);

	const handleToggleExemption = (tax: keyof typeof exemptions) => {
		onChange({
			...exemptions,
			[tax]: !exemptions[tax],
		});
	};

	const handleToggleAll = () => {
		onChange({
			tax1: !areAllSelected,
			tax2: !areAllSelected,
			tax3: !areAllSelected,
			tax4: !areAllSelected,
		});
	};

	return (
		<FormControl fullWidth required>
			<InputLabel shrink>Tax Exemptions</InputLabel>
			<Select
				displayEmpty
				label='Tax Exemptions'
				labelId='tax-exemptions-label'
				multiple
				value={Object.entries(exemptions).reduce((acc, [k, v]) => (v ? [...acc, k] : acc), [])}
				renderValue={(selectedValues) => {
					switch (selectedValues.length) {
						case Object.keys(exemptions).length: {
							return 'All Taxes Exempt';
						}
						case 0: {
							return 'No Taxes Exempt';
						}
						case 1: {
							return '1 Tax Exempt';
						}
						default: {
							return `${selectedValues.length} Taxes Exempt`;
						}
					}
				}}
			>
				<MenuItem
					onClick={() => {
						handleToggleAll();
					}}
					disabled={disabled}
				>
					<Switch
						checked={areAllSelected}
						onClick={(e) => {
							e.stopPropagation();
							handleToggleAll();
						}}
						edge='start'
						disabled={disabled}
					/>
					<ListItemText primary='Exempt all Taxes' />
				</MenuItem>
				{!areAllSelected &&
					Object.keys(exemptions).map((tax: keyof typeof exemptions) => (
						<MenuItem
							key={tax}
							value={tax}
							onClick={() => {
								handleToggleExemption(tax);
							}}
							disabled={disabled}
						>
							<Switch
								checked={exemptions[tax]}
								onClick={(e) => {
									e.stopPropagation();
									handleToggleExemption(tax);
								}}
								edge='start'
								disabled={disabled}
							/>
							<ListItemText
								primary={tax}
								secondary={exemptions[tax] ? 'Tax is exempt' : 'Tax is applied'}
							/>
						</MenuItem>
					))}
			</Select>
		</FormControl>
	);
};
